"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitIdentityMindForm = exports.getCurrentLevel = void 0;
var _dateHelper = require("../../helpers/dateHelper");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getCurrentLevel = exports.getCurrentLevel = function getCurrentLevel(currentLevel, levelIncreaseStatus) {
  if (currentLevel === 1 && levelIncreaseStatus !== 'pass') {
    return 1;
  } else if (currentLevel === 1 && levelIncreaseStatus === 'pass') {
    return 2;
  } else if (currentLevel === 2) {
    return 2;
  } else if (currentLevel === 3) {
    return 3;
  } else {
    return 1;
  }
};
var submitIdentityMindForm = exports.submitIdentityMindForm = function submitIdentityMindForm(props) {
  var alphaPointSessiontoken = props.alphaPointSessiontoken,
    alphaPointUserID = props.alphaPointUserID,
    _props$kycConfig = props.kycConfig,
    type = _props$kycConfig.type,
    requestIdentifier = _props$kycConfig.requestIdentifier,
    submitInfoIdentityMind = props.submitInfoIdentityMind,
    formValues = props.formValues,
    userName = props.userName,
    email = props.email,
    reset = props.reset,
    onSubmit = props.onSubmit;
  var Config = Object.keys(formValues || {}).map(function (key) {
    return {
      Key: key,
      Value: formValues[key]
    };
  });
  Config.push({
    Key: 'email',
    Value: email
  });
  var setUserConfigPayload = {
    UserId: Number(alphaPointUserID),
    UserName: userName,
    Config: Config
  };
  var dob = formValues.dob ? (0, _dateHelper.formatDate)(formValues.dob, 'MM/dd/yyyy') : undefined;
  var userInfo = _objectSpread(_objectSpread({}, formValues), {}, {
    accountName: alphaPointUserID,
    email: email,
    billingFlatNumber: '',
    salutation: '',
    dob: dob
  });
  var clientInfo = {
    alphaPointSessiontoken: alphaPointSessiontoken,
    alphaPointUserID: alphaPointUserID,
    validationStage: 1,
    validator: type
  };
  var validateUserRegistrationPayload = {
    requestIdentifier: requestIdentifier,
    clientInfo: clientInfo,
    userInfo: userInfo
  };
  var submitInfoIdentityMindPayload = {
    validateUserRegistrationPayload: validateUserRegistrationPayload,
    setUserConfigPayload: setUserConfigPayload
  };
  submitInfoIdentityMind(submitInfoIdentityMindPayload);
  reset();
  onSubmit && onSubmit();
};